/**
 * @param value
 * @return {boolean}
 */
export function isEmpty(value) {
    if (value == null) {
        return true;
    }

    if (typeof value === 'string') {
        return !(value.trim().length > 0);
    }

    return value !== value;
}

/**
 * @param value
 * @param {Function} callback
 * @return {null|*}
 */
export function mayBeEmpty(value, callback) {
    if (isEmpty(value)) {
        return null;
    }
    return callback(value);
}
